

import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AppMessageService } from 'src/app/app-message.service';
import { CommonService } from '../services/common.service';
import { environment } from 'src/environments/environment';
import { Region } from '../enums';
import { PortalCountry } from '../interfaces/portal-country.interface';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-reigon-selection',
  templateUrl: '../templates/template1/views/reigon-selection.component.html',
  styleUrls: [
    '../templates/template1/themes/default/less/reigon-seletion-component.less']

})
export class AppReigonSelection implements OnInit {
  @Input() regionUrl: string;
  @Input() regionId: number;
  reigonIdSubscription: Subscription;
  @Input() portalCountries: PortalCountry[];
  @Output() private regionIdChange = new EventEmitter<number>();
  portalImageUrl:string;
  regionTypeEnum=Region;
  browserRegion:any;
  constructor(

    private _appMessageService: AppMessageService,
    private _commonService: CommonService

  ) {

  }
  ngOnInit() {
    if (this.regionUrl) {
      this.portalImageUrl=this.regionUrl;
      this.getsubscribeReigonId();
    }
  }

  public onRegionChange(regionId: number) {
    this.browserRegion = this.portalCountries.find((item: any) => item.regionId === regionId);
    if(this.browserRegion){
    this.portalImageUrl = this.getImageByRegion(regionId);
    this.regionIdChange.emit(regionId);
    }
  
  }

  getsubscribeReigonId() {
    this.reigonIdSubscription = this._appMessageService.getReigonIdSelect()
      .subscribe((reigonID: number) => {
        if (reigonID) {
          this.portalImageUrl = this.getImageByRegion(reigonID);
         
        }
      });
  }

  ngOnDestroy(): void {
    if (this.reigonIdSubscription) {
        this.reigonIdSubscription.unsubscribe();
    }
  }

  getImageByRegion(regionCode: number) {
    let imageUrl;
    switch (regionCode) {
      case this.regionTypeEnum.Africa:
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-africa_Shadow.png';
        break;
      case this.regionTypeEnum.NorthAmerica:
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-north-america_Shadow.png';
        break;
      case this.regionTypeEnum.LatinAmerica:
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-latin-america.png';
        break;
        case this.regionTypeEnum.Asia:
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-asia_Shadow.png';
        break;
      case this.regionTypeEnum.Europe:
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-europe_Shadow.png';
        break;
      case this.regionTypeEnum.MiddleEast:
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-middle-east_Shadow.png';
        break;
      case this.regionTypeEnum.Caribbean:
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-caribbean_Shadow.png';
        break;

      case this.regionTypeEnum.PacificRim:
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-pacific-rim_Shadow.png';
        break;

      default:
        imageUrl = environment.cdnURL + '/flpi/assets/maps/shadow/img-map-north-america_Shadow.png';
        break;
    }
    return imageUrl;
  }


}
